import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "styled-components";
import Wrapper from "../atoms/Wrapper";
import Link from "../atoms/Link";
import { Favorite, FavoriteBorder } from "@material-ui/icons";
import { post_like, post_unlike } from "../../actions/introduction";
import Image from "../atoms/Image";

const StyledLink = styled(Link)`
  align-items: flex-start;
  max-width: 23rem;
  min-width: 23rem;
  margin: 1rem 2.8rem 1rem 0.2rem;

  @media (max-width: 570px) {
    max-width: 90vw;
    min-width: 18rem;
    margin: 1rem 2.2rem 1rem 0.2rem;
  }
`;

const OuterWrapper = styled(Wrapper)`
  flex-direction: column;
  box-shadow: 0 2px 4px ${(props) => props.theme.colors.shadow};
  border-radius: 3px;
  width: 100%;
  background: ${(props) => props.theme.colors.white};
`;
const Bottom = styled(Wrapper)`
  width: 100%;
  padding: 0.5rem 1rem;
  flex-direction: column;
`;

const BottomDescription = styled(Wrapper)`
  width: 100%;
  padding: 0.5rem 0 0.2rem 0;
`;

const BottomBottom = styled(Wrapper)`
  width: 100%;
  justify-content: flex-end;
`;

const StyledFavoriteIcon = styled(Favorite)`
  color: ${(props) => props.theme.colors.red};
`;
const Like = styled(Wrapper)`
  border-radius: 99999px;
  padding: 0.05rem 0.5rem;
  &:hover {
    background: ${(props) => props.theme.colors.red100};
  }
`;
const StyledFavoriteBorderIcon = styled(FavoriteBorder)`
  color: ${(props) =>
    props.hover ? props.theme.colors.red : props.theme.colors.gray300};
`;
const LikeCount = styled(Wrapper)`
  color: ${(props) =>
    props.like
      ? props.theme.colors.red
      : props.hover
      ? props.theme.colors.red
      : props.theme.colors.gray400};
  margin-left: 0.3rem;
`;

const BottomTop = styled(Wrapper)`
  width: 100%;
  justify-content: flex-start;

  border-bottom: 1px solid ${(props) => props.theme.colors.gray100};
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
`;
const Owner = styled(Wrapper)``;
const OwnerName = styled(Wrapper)`
  color: ${(props) => props.theme.colors.gray};
  font-size: 0.8rem;
  width: calc(100% - 32px - 5px - 0.5rem);
`;
const OwnerAvatarWrapper = styled(Wrapper)`
  width: 32px;
  height: 32px;
  border-radius: 99999px;
  margin: 5px 0.5rem 5px 5px;
  background: ${(props) => props.theme.colors.white100};
  overflow: hidden;
  z-index: 2;
`;

const StreamItem = (props) => {
  const dispatch = useDispatch();
  const [hover, set_hover] = React.useState(false);
  const [like, set_like] = React.useState(props.item.is_liked);
  const [dummy_like, set_dummy_like] = React.useState(0);

  const { isSignedIn } = useSelector(
    (state) => state.reduxTokenAuth.currentUser
  );

  React.useEffect(() => {
    set_like(props.item.is_liked);
  }, [props.item.is_liked]);

  const handle_like = (e) => {
    e.preventDefault();

    if (isSignedIn) {
      set_like((prev) => {
        if (prev) {
          dispatch(post_unlike(props.item.id));
          set_dummy_like(0);
        } else {
          dispatch(post_like(props.item.id));
          set_dummy_like(1);
        }
        return !prev;
      });
    }
  };

  return (
    <StyledLink to={`/forum/introductions/${props.item && props.item.id}`}>
      <OuterWrapper>
        <Bottom>
          <BottomTop>
            <Owner>
              <OwnerAvatarWrapper>
                <Image
                  src={props.item.owner.avatar}
                  default_width="32px"
                  default_height="32px"
                  default_mobile_width="32px"
                  default_mobile_height="32px"
                />
              </OwnerAvatarWrapper>
              <OwnerName>
                {props.item.owner.name &&
                  props.item.owner.name.slice(0, 8) +
                    (props.item.owner.name.length > 8 ? "…" : "")}
                による紹介
              </OwnerName>
            </Owner>
          </BottomTop>
          <BottomDescription>
            {props.item.favorite_point_description_0 &&
              props.item.favorite_point_description_0.slice(0, 16) +
                (props.item.favorite_point_description_0.length > 16
                  ? "…"
                  : "")}
          </BottomDescription>
          <BottomBottom>
            {isSignedIn ? (
              <Like
                onClick={handle_like}
                onMouseEnter={() => set_hover(true)}
                onMouseLeave={() => set_hover(false)}
              >
                {like ? (
                  <StyledFavoriteIcon hover={hover} />
                ) : (
                  <StyledFavoriteBorderIcon hover={hover} />
                )}
                <LikeCount like={like} hover={hover}>
                  {props.item.introduction_likes_count + dummy_like}
                </LikeCount>
              </Like>
            ) : (
              <Tooltip title="ログインが必要です。">
                <Like
                  onClick={handle_like}
                  onMouseEnter={() => set_hover(true)}
                  onMouseLeave={() => set_hover(false)}
                >
                  {like ? (
                    <StyledFavoriteIcon hover={hover} />
                  ) : (
                    <StyledFavoriteBorderIcon hover={hover} />
                  )}
                  <LikeCount like={like} hover={hover}>
                    {props.item.introduction_likes_count + dummy_like}
                  </LikeCount>
                </Like>
              </Tooltip>
            )}
          </BottomBottom>
        </Bottom>
      </OuterWrapper>
    </StyledLink>
  );
};

export default StreamItem;
